let top_menu = {
  home: "首页",
  package: "套餐购买",
  api: "API提取",
  application: "应用场景",
  resource: "资源中心",
  login: "登录",
  register: "注册",
  sign_out: "退出"
}
export default top_menu


// WEBPACK FOOTER //
// ./src/assets/lang/zh/top/index.js